var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{attrs:{"id":"header"}},[_c('img',{attrs:{"src":require("../../public/images/marca/Marca.png"),"alt":""}}),_c('a',{attrs:{"href":"#description"}},[_c('arrowdown')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }